import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SignoutPage from 'ziphy-web-shared/pages/app/SignoutPage';
import ClientChatPage from '@core/src/pages/clientChat/ClientChatPage';
import ExploreLiveqBookingPage from '@core/src/pages/explore/ExploreLiveqBookingPage';
import MyOrdersPage from '@core/src/pages/myOrders/MyOrdersPage';
import DefaultLayout from '@src/layouts/DefaultLayout';
import AuthProvider from '@library/providers/AuthProvider';
import PageProvider from '@library/providers/PageProvider';
import LoginPage from '@nedoShared/modules/auth/LoginPage';
import HomePage from '@nedoShared/pages/HomePage';
import ApptPage from '@pages/ApptPage';
import ApptsPage from '@pages/ApptsPage';
import ClientProfilePage from '@pages/ClientProfilePage';
import CocPatientPage from '@pages/CocPatientPage';
import CocPatientsPage from '@pages/CocPatientsPage';
import ErrorPage from '@pages/errors/ErrorPage';
import PaymentMethodsPage from '@pages/PaymentMethodsPage';
import BookingFinishPage from '@booking/pages/bookingFinish/BookingFinishPage';
import BookingSelectPatientsPage from '@booking/pages/bookingSelectPatients/BookingSelectPatientsPage';
import BookingSymptomsPage from '@booking/pages/bookingSymptoms/BookingSymptomsPage';
import BookingTimePickerPage from '@booking/pages/bookingTimePicker/BookingTimePickerPage';
import PsPatientPage from '@ps/pages/PsPatientPage';
import ExploreLiveqStarterPage from '@pages/explore/ExploreLiveqStarterPage';
import ExploreLiveqTelehealthPage from '@pages/explore/ExploreLiveqTelehealthPage';
import HomePageWrapper from '@core/src/pages/HomePageWrapper';
export const routes = [
    {
        id: 'home',
        path: '/',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(HomePageWrapper, { isClient: true }) }) }) })),
        exact: true,
    },
    {
        id: 'homeInvitation',
        path: '/r/:invitationCode?',
        element: (_jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(HomePage, { registration: true }) }) })),
    },
    {
        id: 'bookPatients',
        tags: ['hideNearestBar', 'hideRightSidebar'],
        path: '/book/patients',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(BookingSelectPatientsPage, {}) }) }) })),
    },
    {
        id: 'bookSymptoms',
        tags: ['hideNearestBar', 'hideRightSidebar'],
        path: '/book/symptoms',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, Object.assign({ fullHeight: true }, { children: _jsx(PageProvider, { children: _jsx(BookingSymptomsPage, {}) }) })) })),
    },
    {
        id: 'bookDate',
        tags: ['hideNearestBar', 'hideRightSidebar'],
        path: '/book/date',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(BookingTimePickerPage, {}) }) }) })),
    },
    {
        id: 'bookFinish',
        tags: ['hideNearestBar', 'hideRightSidebar'],
        path: '/book/finish',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(BookingFinishPage, {}) }) }) })),
    },
    {
        id: 'appts',
        path: '/appointments',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(ApptsPage, {}) }) }) })),
    },
    {
        id: 'appt',
        tags: ['hideNearestBar'],
        path: '/appointments/:appointmentId/:encounterId?',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, Object.assign({ onEnterScrollToTop: true }, { children: _jsx(ApptPage, {}) })) }) })),
    },
    {
        id: 'profile',
        path: '/profile',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(ClientProfilePage, {}) }) }) })),
    },
    {
        id: 'patients',
        path: '/circle',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(CocPatientsPage, {}) }) }) })),
    },
    {
        id: 'patient',
        path: '/circle/:patientId',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(CocPatientPage, {}) }) }) })),
    },
    {
        id: 'exploreLiveqConsultation',
        tags: ['hideNearestBar'],
        path: '/explore/consultation/:consultationId',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, Object.assign({ hasSidebar: false }, { children: _jsx(PageProvider, { children: _jsx(ExploreLiveqTelehealthPage, {}) }) })) })),
    },
    {
        id: 'exploreLiveqSurvey',
        tags: ['hideNearestBar'],
        path: '/explore/survey/:surveyId',
        element: (_jsx(DefaultLayout, Object.assign({ hasSidebar: false }, { children: _jsx(PageProvider, { children: _jsx(ExploreLiveqBookingPage, {}) }) }))),
    },
    {
        id: 'exploreLiveqSurvey',
        tags: ['hideNearestBar'],
        path: '/explore/anonym/:surveyId/:token',
        element: (_jsx(DefaultLayout, Object.assign({ hasSidebar: false }, { children: _jsx(PageProvider, { children: _jsx(ExploreLiveqBookingPage, {}) }) }))),
    },
    {
        id: 'exploreLiveqBooking',
        tags: ['hideNearestBar'],
        path: '/explore/booking/:serviceId/:regionId',
        element: (_jsx(DefaultLayout, Object.assign({ hasSidebar: false }, { children: _jsx(PageProvider, { children: _jsx(ExploreLiveqStarterPage, {}) }) }))),
    },
    {
        id: 'myOrders',
        path: '/orders',
        tags: ['hideRightSidebar', 'hideNearestBar'],
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(MyOrdersPage, {}) }) }) })),
    },
    {
        id: 'clientChat',
        path: '/orders/:orderId/chat/:chatId',
        tags: ['hideRightSidebar', 'hideNearestBar'],
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(ClientChatPage, {}) }) }) })),
    },
    {
        id: 'psPatient',
        path: '/circle/:patientId/practice/:practiceId/:categoryId?',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(PsPatientPage, {}) }) }) })),
    },
    {
        id: 'pms',
        path: '/payment-methods',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(PaymentMethodsPage, {}) }) }) })),
    },
    {
        id: 'login',
        path: '/login',
        element: (_jsx(DefaultLayout, Object.assign({ hasSidebar: false, fullHeight: true }, { children: _jsx(PageProvider, { children: _jsx(LoginPage, { waitAllConfigureSteps: true }) }) }))),
    },
    {
        id: 'signout',
        path: '/signout',
        element: (_jsx(AuthProvider, { children: _jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(SignoutPage, {}) }) }) })),
    },
    {
        id: 'error',
        path: '*',
        element: (_jsx(DefaultLayout, { children: _jsx(PageProvider, { children: _jsx(ErrorPage, {}) }) })),
    },
];
